import Fuse from 'fuse.js'
// let listItems = []
export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.formattedBillItems
      if (this.searchedData.length > 0) {
        result = this.searchedData
      } else {
        if (this.searchQuery) {
          result = []
        }
      }
      return result ? result.slice(this.from, this.to) : []
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      return this.searchedData && this.searchedData.length > 0
        ? this.searchedData.length
        : this.formattedBillItems && this.formattedBillItems.length > 0
        ? this.formattedBillItems.length
        : 0
    },
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: '',
      searchedData: [],
      fuseSearch: null,
    }
  },
  methods: {
    createFuseSearch(keys) {
      this.fuseSearch = new Fuse(this.formattedBillItems, {
        keys: keys,
        threshold: 0.3,
      })
    },

    formatDataLocaleString(oldData) {
      let d = new Date(oldData)
      let n = d.toLocaleString()
      return n
    },

    sortChange({ prop, order }) {
      if (prop === undefined && order === undefined) {
        this.formattedBillItems.sort((a, b) => {
          return false
        })
      }

      if (prop) {
        this.formattedBillItems.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return aVal < bVal ? 1 : -1
        })
      } else {
        this.formattedBillItems.sort((a, b) => {
          return a > b ? 1 : -1
        })
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    // this.fuseSearch = new Fuse(this.formattedBillItems, {
    //   keys: ['name', 'position', 'date'],
    //   threshold: 0.3
    // });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.formattedBillItems
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
      this.pagination.currentPage = 1
      this.$emit('reset-pagination', 1)
    },
  },
}
